import { createContext, useContext } from "react";
import { DEFAULT_VENUE_TIMEZONE } from "common-fe/venueTime";

// #1788 — the venue timezone for whatever show this board is rendering.
//
// A context rather than a prop because the two things that most need it are
// the furthest from the data: VenueClock takes no props at all (it is
// dropped into ScoreboardFrame's bottom-right slot), and ClassHeader sits a
// layout component down (RankedListLayout, SingleEntryLayout) from the page
// that owns the poll.
// Threading a `timeZone` prop through all of those would mean every future
// layout has to remember to forward it, and the failure mode of forgetting
// is silent — the board renders a plausible time that is simply the wrong
// city's. A context makes the default explicit in exactly one place.
//
// The value is ALREADY RESOLVED by score-api (scoreboard-public.js sends
// `venueTimezone` as a string Intl accepts). The Pacific default here is
// only for the first render before any poll has landed, and for the
// non-scoreboard pages that don't provide it — it deliberately matches what
// this surface did for every show before #1788, so nothing regresses.
const VenueTimeZoneContext = createContext(DEFAULT_VENUE_TIMEZONE);

export function VenueTimeZoneProvider({ timeZone, children }) {
  return (
    <VenueTimeZoneContext.Provider value={timeZone || DEFAULT_VENUE_TIMEZONE}>
      {children}
    </VenueTimeZoneContext.Provider>
  );
}

export function useVenueTimeZone() {
  return useContext(VenueTimeZoneContext);
}

export default VenueTimeZoneContext;
